import { LegalPage } from "../../components/LegalPage";
import {
  LegalMarkdown,
  effectiveOf,
  titleOf,
} from "../../components/LegalMarkdown";
// THE DOCUMENT LIVES IN docs/legal/, NOT HERE.
//
// It used to be JSX in this file, which meant the text a visitor read and the
// text the product asks people to ACCEPT were two artifacts that could
// disagree. legal_acceptances records a sha256 of the markdown, so prose kept
// here would let an edit change what people read without changing what they
// are recorded as having agreed to — exactly what the hash exists to catch.
//
// `pnpm legal:check` fails CI when the generated registry drifts from these
// files, so the page, the hash and the consent screen are one source.
import markdown from "../../../../../docs/legal/acceptable-use.md?raw";

export function Aup() {
  return (
    <LegalPage
      title={titleOf(markdown)}
      description="WeConsult Rx acceptable use policy: prohibited activities, content restrictions, and consequences for violations."
      path="/aup"
      effective={effectiveOf(markdown)}
    >
      <LegalMarkdown markdown={markdown} />
    </LegalPage>
  );
}
